import { AuthorizationData } from '@kaseya-shared';

const actionScope = '[Third Party SSO]';

export class LoadAuthorizationData {
  static readonly type = `${actionScope} Load Authorization Data`;
  constructor(public ssoToken: string) {}
}

export class LoadAuthorizationDataCompleted {
  static readonly type = `${actionScope} Load Authorization Data Completed`;
  constructor(public authorizationData: AuthorizationData) {}
}

export class LoadAuthorizationDataError {
  static readonly type = `${actionScope} Load Authorization Data Error`;
}
